<template>
  <div class="participants-panel flex-grow-1">
    <v-row
      no-gutters
      justify="center"
      align="center"
      class="grey lighten-5 pa-1"
    >
      <div
        class="subtitle-2 font-weight-bold mr-1 grey--text text--darken-2"
      >
        Submitted by
      </div>
      <researcher-avatar-cluster :researchers="researchers" />
    </v-row>
  </div>
</template>

<script>
import ResearcherAvatarCluster from '@/components/Common/ResearcherAvatarCluster';
import { typeHelpers } from '@/modules';
import { Researcher } from '@/models';
export default {
  name: 'ParticipantsPanel',
  components: { ResearcherAvatarCluster },
  props: {
    researchers: {
      type: Array,
      default: () => [],
      validator: (field) =>
        typeHelpers.isArrayOfType(field, Researcher),
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';
.participants-panel {
  border-bottom: 1px solid map-get($grey, 'lighten-2') !important;
}
</style>
